import React, { Component } from "react";
import { Table, TableBody } from "@material-ui/core/";
import TotalRow from "./TotalRow";
import TaxDiscountRow from "./TaxDiscountRow";
import TotalBillRow from "./TotalBillRow";
import { COP as currency } from "../../../../../utils";
class CartFooter extends Component {
  state = {};

  render() {
    const { cartArray, summary } = this.props;
    if (summary.noOfItems === 0) {
      return null;
    }
    const totalQtyText = `${summary.noOfItems} (${summary.noOfInividualItems})`;
    const totalPrice = currency(summary.total).format("$");
    const netTotal = currency(summary.netTotal).format("$");
    const totalPay = currency(summary.totalPay).format("$");

    return (
      <Table style={{ marginTop: "50px", marginBottom: "20px" }}>
        <TableBody>
          <TotalRow totalQtyText={totalQtyText} totalPrice={totalPrice} />
          <TaxDiscountRow cartArray={cartArray} summary={summary} />
          <TotalBillRow totalPay={totalPay} netTotal={netTotal} />
        </TableBody>
      </Table>
    );
  }
}

export default CartFooter;
